import type { PaymentCard } from '@api/types';
import bitpaceImg from '@images/billing/bitpace.svg';
import americanExpressCardImg from '@images/billing/card/amex.svg';
import dinersCardImg from '@images/billing/card/diners-club.svg';
import discoverCardImg from '@images/billing/card/discover.svg';
import jsbCardImg from '@images/billing/card/jcb.svg';
import maestroCardImg from '@images/billing/card/maestro.svg';
import masterCardImg from '@images/billing/card/mastercard.svg';
import otherCardImg from '@images/billing/card/other.svg';
import ruPayCardImg from '@images/billing/card/ru-pay.svg';
import unionPayCardImg from '@images/billing/card/union-pay.svg';
import visaCardImg from '@images/billing/card/visa.svg';
import centroBillImg from '@images/billing/centroBill.svg';
import epochImg from '@images/billing/epoch.svg';
import priorityBillImg from '@images/billing/priority-bill.svg';
import { PaymentCardBrand, PaymentType } from '@shared/types';
import { Billing } from '@shared/types';
import { ProductType } from '@shared/types/invoice';

export function getBillingUnsubscribeUrl(billing: Billing): string {
    return {
        [Billing.CentroBill]: 'https://centrohelp.com',
        [Billing.Epoch]: 'https://epoch.com/billing_support/find_purchase',
        [Billing.UpGate]: 'https://prioritybill.com/',
        [Billing.PayGarden]: '',
        [Billing.Bitpace]: 'https://www.bitpace.com/',
    }[billing];
}

export function getBillingCardBrand(brand: PaymentCardBrand | PaymentCard['brand'] | ''): string {
    return {
        [PaymentCardBrand.AmericanExpress]: americanExpressCardImg,
        [PaymentCardBrand.Diners]: dinersCardImg,
        [PaymentCardBrand.Jsb]: jsbCardImg,
        [PaymentCardBrand.Maestro]: maestroCardImg,
        [PaymentCardBrand.Mastercard]: masterCardImg,
        [PaymentCardBrand.Visa]: visaCardImg,
        [PaymentCardBrand.UnionPay]: unionPayCardImg,
        [PaymentCardBrand.RuPay]: ruPayCardImg,
        [PaymentCardBrand.Discover]: discoverCardImg,
        ['']: otherCardImg,
    }[brand];
}

export function getBillingUrl(billing: Billing): string {
    return {
        [Billing.CentroBill]: 'https://centrobill.com',
        [Billing.Epoch]: 'https://epoch.com',
        [Billing.UpGate]: 'https://prioritybill.com/',
        [Billing.PayGarden]: '',
        [Billing.Bitpace]: 'https://www.bitpace.com/',
    }[billing];
}

export function getBillingIcon(billing: Billing): string {
    return {
        [Billing.CentroBill]: centroBillImg,
        [Billing.Epoch]: epochImg,
        [Billing.UpGate]: priorityBillImg,
        [Billing.PayGarden]: epochImg,
        [Billing.Bitpace]: bitpaceImg,
    }[billing];
}

export function getEventPaymentType(productType: ProductType): PaymentType | undefined {
    switch (productType) {
        case ProductType.Subscription:
            return PaymentType.Membership;
        case ProductType.TimePackage:
            return PaymentType.ExtraMinutes;
        default:
            return;
    }
}

/**
 * Utility to calculate product total price for a period
 */
export function getTotalPrice(price: number, period?: number): number {
    return price * ((period || 30) / 30);
}
